export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/web_traffic.693e220.svg";